import axiosInit from 'axios'
import Configure from './configure'
import store from '../store/index'
import router from '../router'
import { Message } from 'element-ui'
axiosInit.defaults.baseURL = Configure.base_url
function setCookie (name, value) {
  document.cookie = name + '=' + escape(value) + ';path=/'
}
let languageType
let locale = localStorage.getItem(Configure.cookie_prefix + 'locale')
if (!locale || locale === 'cn') {
  languageType = null
} else if (locale === 'en') {
  languageType = 1
}

axiosInit.interceptors.request.use((config) => {
  // 获取到token
  let token
  if (store.state.Auth.userType === 3) {
    token = store.state.Auth.token
  }
  // let companyId = store.state.Auth.companyId
  let companyItem = localStorage.getItem('companyData')
  let companyId
  if (companyItem && companyItem !== 'undefined' && companyItem !== 'null') {
    companyItem = JSON.parse(companyItem)
    companyId = companyItem.companyId
  } else {
    companyId = ''
  }
  config.headers.isStudent = 1
  if (token) {
    if (config.params) {
      config.params.token = token
      config.params.languageType = languageType
      if (companyId) {
        config.params.companyId = companyId
      }
    } else {
      if (config.method === 'get' || config.method === 'delete') {
        config.params = {}
        config.params.token = token
        config.params.languageType = languageType
        if (companyId) {
          config.params.companyId = companyId
        }
      } else {
        if (config.data) {
          config.data.token = token
          config.data.languageType = languageType
          if (companyId) {
            config.data.companyId = companyId
          }
        } else {
          config.data = {}
          config.data.token = token
          config.data.languageType = languageType
          if (companyId) {
            config.data.companyId = companyId
          }
        }
      }
    }
  } else {
    if (config.params) {
      if (companyId) {
        config.params.companyId = companyId
      }
      config.params.languageType = languageType
    } else {
      if (config.method === 'get' || config.method === 'delete') {
        config.params = {}
        if (companyId) {
          config.params.companyId = companyId
        }
        config.params.languageType = languageType
      } else {
        if (config.data) {
          if (companyId) {
            config.data.companyId = companyId
          }
          config.data.languageType = languageType
        } else {
          config.data = {}
          if (companyId) {
            config.data.companyId = companyId
          }
          config.data.languageType = languageType
        }
      }
    }
  }
  return config
}, function (err) {
  return Promise.reject(err)
})

/* axiosInit.interceptors.request.use((config) => {
  // 获取到token
  let token = store.state.Auth.token
  if (token) {
    if (config.params) {
      config.params.token = token
    } else {
      if (config.method === 'get' || config.method === 'delete') {
        config.params = {}
        config.params.token = token
      } else {
        if (config.data) {
          config.data.token = token
        } else {
          config.data = {}
          config.data.token = token
        }
      }
    }
  }
  return config
}, function (err) {
  return Promise.reject(err)
}) */

/**
 * 所有ajax的请求返回值的处理
 */
let isToken = false
axiosInit.interceptors.response.use((rsp) => {
  // 在这里对返回的数据进行处理
  // switch (rsp.data.resultCode) {
  //   case -1:
  //     // Message.error('登录已失效，请重新登录！')
  //     setTimeout(function () {
  //       // 清空登录信息
  //       store.dispatch('logout').then(() => {
  //         // 重定向到登录页面
  //         setCookie('logout', 1)
  //         router.push({ name: 'Login', query: {referer: window.location.href} })
  //       })
  //     }, 500)
  //     break
  //   case -5:
  //     Message.error('角色权限已变更，请重新登录！')
  //     setTimeout(function () {
  //       // 清空登录信息
  //       store.dispatch('logout').then(() => {
  //         // 重定向到登录页面
  //         router.push({name: 'Login'})
  //       })
  //     }, 500)
  //     break
  // }
  // return rsp
  if (rsp.data.resultCode === -1) {
    if (!isToken) {
      isToken = true
      store.dispatch('logout').then(() => {
        // 重定向到登录页面
        setCookie('logout', 1)
        if (localStorage.getItem('agentUrl')) {
          router.push({
            name: 'FranReg',
            params: {
              id: localStorage.getItem('agentUrl')
            },
            query: {
              referer: window.location.href
            }
          })
        } else {
          router.push({
            name: 'Login',
            query: {
              referer: window.location.href
            }
          })
        }
      })
      setTimeout(() => {
        isToken = false
      }, 2000)
      // return rsp
    }
  } else {
    return rsp
  }
}, (error) => {
  // switch (error.response.status) {
  //   case 401:
  //     // Message.error('登录已失效，请重新登录！')
  //     setTimeout(function () {
  //       // 清空登录信息
  //       store.dispatch('logout').then(() => {
  //         // 重定向到登录页面
  //         setCookie('logout', 1)
  //         router.push({ name: 'Login', query: {referer: window.location.href} })
  //       })
  //     }, 500)
  //     break
  //   case 403:
  //     Message.error(error.response.data.resultMessage)
  //     setTimeout(function () {
  //       // 清空登录信息
  //       store.dispatch('logout').then(() => {
  //         // 重定向到登录页面
  //         router.push({name: 'Login'})
  //       })
  //     }, 500)
  //     break
  //   case 404:
  //     Message.error('服务器错误，请联系管理员！')
  //     break
  //   case 500:
  //     Message(error.response.data.message)
  //     break
  //   case 400:
  //     if (error.response.data.resultCode === -1) {
  //       Message.error('请先登录账号!')
  //       setTimeout(function () {
  //         // 清空登录信息
  //         store.dispatch('logout').then(() => {
  //           // 重定向到登录页面
  //           router.push({ name: 'Login', query: {referer: window.location.href} })
  //         })
  //       }, 500)
  //     } else {
  //       Message(error.response.data.resultMessage)
  //     }
  //     break
  //   case 503:
  //     Message('服务器错误，请重新尝试操作！')
  //     break
  // }
  // return Promise.reject(error)
  if (error.response.status === 401 || error.response.status === 403) {
    if (!isToken) {
      isToken = true
      // Message.error('登录已失效，请重新登录！')
      store.dispatch('logout').then(() => {
        // 重定向到登录页面
        setCookie('logout', 1)
        if (localStorage.getItem('agentUrl')) {
          router.push({
            name: 'FranReg',
            params: {
              id: localStorage.getItem('agentUrl')
            },
            query: {
              referer: window.location.href
            }
          })
        } else {
          router.push({
            name: 'Login',
            query: {
              referer: window.location.href
            }
          })
        }
      })
      setTimeout(() => {
        isToken = false
      }, 2000)
      return Promise.reject(error)
    }
  } else if (error.response.status === 400) {
    if (!isToken) {
      isToken = true
      // Message.error('登录已失效，请重新登录！')
      store.dispatch('logout').then(() => {
        // 重定向到登录页面
        setCookie('logout', 1)
        if (localStorage.getItem('agentUrl')) {
          router.push({
            name: 'FranReg',
            params: {
              id: localStorage.getItem('agentUrl')
            },
            query: {
              referer: window.location.href
            }
          })
        } else {
          router.push({
            name: 'Login',
            query: {
              referer: window.location.href
            }
          })
        }
      })
      setTimeout(() => {
        isToken = false
      }, 2000)
      return Promise.reject(error)
    }
  } else if (error.response.status === 404) {
    Message(error.response.data.error)
    return Promise.reject(error)
  } else {
    Message(error.response.data.message)
    return Promise.reject(error)
  }
})

export default axiosInit



// WEBPACK FOOTER //
// ./src/global/axios.js